const countries = {
  fr: { en: "France", fr: "France" },
  ca: { en: "Canada", fr: "Canada" },
  uk: { en: "United Kingdom", fr: "Royaume-Uni" },
  us: { en: "United States", fr: "États-Unis" },
  ka: { en: "Kazakhstan", fr: "Kazakhstan" },
  de: { en: "Germany", fr: "Allemagne" },
  es: { en: "Spain", fr: "Espagne" },
  it: { en: "Italy", fr: "Italie" },
  in: { en: "India", fr: "Inde" },
  jp: { en: "Japan", fr: "Japon" },
  cn: { en: "China", fr: "Chine" },
  br: { en: "Brazil", fr: "Brésil" },
  mx: { en: "Mexico", fr: "Mexique" },
  tn: { en: "Tunisia", fr: "Tunisie" },
  be: { en: "Belgium", fr: "Belgique" },
  lu: { en: "Luxembourg", fr: "Luxembourg" },

  // Europe
  nl: { en: "Netherlands", fr: "Pays-Bas" },
  ch: { en: "Switzerland", fr: "Suisse" },
  at: { en: "Austria", fr: "Autriche" },
  se: { en: "Sweden", fr: "Suède" },
  no: { en: "Norway", fr: "Norvège" },
  dk: { en: "Denmark", fr: "Danemark" },
  fi: { en: "Finland", fr: "Finlande" },
  pt: { en: "Portugal", fr: "Portugal" },
  gr: { en: "Greece", fr: "Grèce" },
  pl: { en: "Poland", fr: "Pologne" },
  cz: { en: "Czech Republic", fr: "République tchèque" },
  hu: { en: "Hungary", fr: "Hongrie" },
  ro: { en: "Romania", fr: "Roumanie" },
  bg: { en: "Bulgaria", fr: "Bulgarie" },
  hr: { en: "Croatia", fr: "Croatie" },
  rs: { en: "Serbia", fr: "Serbie" },
  ua: { en: "Ukraine", fr: "Ukraine" },

  // Middle East & Africa
  ma: { en: "Morocco", fr: "Maroc" },
  dz: { en: "Algeria", fr: "Algérie" },
  eg: { en: "Egypt", fr: "Égypte" },
  za: { en: "South Africa", fr: "Afrique du Sud" },
  ng: { en: "Nigeria", fr: "Nigéria" },
  ke: { en: "Kenya", fr: "Kenya" },
  gh: { en: "Ghana", fr: "Ghana" },
  ae: { en: "United Arab Emirates", fr: "Émirats arabes unis" },
  sa: { en: "Saudi Arabia", fr: "Arabie saoudite" },
  qa: { en: "Qatar", fr: "Qatar" },
  il: { en: "Israel", fr: "Israël" },

  // Asia
  kr: { en: "South Korea", fr: "Corée du Sud" },
  sg: { en: "Singapore", fr: "Singapour" },
  my: { en: "Malaysia", fr: "Malaisie" },
  th: { en: "Thailand", fr: "Thaïlande" },
  vn: { en: "Vietnam", fr: "Vietnam" },
  id: { en: "Indonesia", fr: "Indonésie" },
  pk: { en: "Pakistan", fr: "Pakistan" },
  bd: { en: "Bangladesh", fr: "Bangladesh" },
  ph: { en: "Philippines", fr: "Philippines" },

  // Americas
  ar: { en: "Argentina", fr: "Argentine" },
  cl: { en: "Chile", fr: "Chili" },
  co: { en: "Colombia", fr: "Colombie" },
  pe: { en: "Peru", fr: "Pérou" },
  ve: { en: "Venezuela", fr: "Venezuela" },
  uy: { en: "Uruguay", fr: "Uruguay" },

  // Others
  au: { en: "Australia", fr: "Australie" },
  nz: { en: "New Zealand", fr: "Nouvelle-Zélande" },
};

export default countries;